import { ApiClient } from '~/clients/ApiClient'

export const useApi = () => {
  const runtimeConfig = useRuntimeConfig()

  return new ApiClient(runtimeConfig.public.FAKE_HEADER, runtimeConfig.public.API_BASE_URL)
}
